import React, { useState, useEffect } from "react";
import classnames from "classnames";
import styles from "./SpinningLoader.module.scss";
import { addStaticRootToUrl } from "@src/utils/static";
import { SpinningLoaderSizes } from "./SpinningLoaderSizes";

const NUM_LOADER_TICKS = 8;
const ROTATION_DEGREES_PER_TICK = 360 / NUM_LOADER_TICKS;

interface SpinningLoaderProps {
  whiteBackground?: boolean;
  size?: string;
}

export default function SpinningLoader({
  whiteBackground,
  size = SpinningLoaderSizes.Large,
}: SpinningLoaderProps) {
  const [tick, setTick] = useState(1);
  const rotationAngle = (tick - 1) * ROTATION_DEGREES_PER_TICK;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTick((prevTick) => (prevTick === NUM_LOADER_TICKS ? 1 : prevTick + 1));
    }, 100);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className={classnames(styles.root, {
        [styles.whiteBackground]: whiteBackground,
      })}
      data-testid="loader"
    >
      <img
        className={classnames(styles.loader, styles[size])}
        style={{ transform: `rotate(${rotationAngle}deg)` }}
        src={addStaticRootToUrl("images/spinning_loader.png")}
        alt="Loading..."
      />
    </div>
  );
}
